export default ($) => {

	// fix accessibility issues with the GravityForms dropdown date picker fields
	let gfMonthFields = $('.gfield_date_dropdown_month select');
	let gfDayFields = $('.gfield_date_dropdown_day select');
	let gfYearFields = $('.gfield_date_dropdown_year select');

	for (let mf = 0; mf < gfMonthFields.length; mf++) {
		$(gfMonthFields[mf]).attr('aria-label', 'Month');
	}

	for (let df = 0; df < gfDayFields.length; df++) {
		$(gfDayFields[df]).attr('aria-label', 'Day');
	}

	for (let yf = 0; yf < gfYearFields.length; yf++) {
		$(gfYearFields[yf]).attr('aria-label', 'Year');
	}
}